module.exports = __webpack_public_path__ + "img/A6.9b9b87e3.svg";